import { Link } from 'react-router-dom';
import { Helmet } from 'react-helmet-async';
import axios from "axios";
import React, { useState, useEffect } from "react";
import { useLocation } from 'react-router-dom'; // For getting the current route
import api from '../api';
import { Eye, EyeOff } from 'react-feather';

function StaffLogin(props) {
    const baseUrl = process.env.REACT_APP_BASE_URL;
    const [formError, setFormError] = useState(false);
    const [errorMsg, setErrorMsg] = useState('');
    const [loading, setLoading] = useState(false);
    const [UsernameError,setUsernameError]=useState(false);  
    const [PasswordError,setPasswordError]=useState(false);
    const [showPassword, setShowPassword] = useState(false);
    const [loginFormData, setLoginFormData] = useState({
        username: '',
        password: '',
    });
    
    const inputHandler = (event) => {
        setLoginFormData({
            ...loginFormData,
            [event.target.name]: event.target.value,
        });
    };
    
    const submitHandler = async (event) => {
        if(loginFormData.username.length < 3){
            setUsernameError(true); 
            return;
        } else {
            setUsernameError(false);
        }

        if(loginFormData.password.length < 7){
            setPasswordError(true); 
            return;
        } else {
            setPasswordError(false);
        }

        setLoading(true);
        setErrorMsg("");
        event.preventDefault();
        const formData = {
            username: loginFormData.username.toLowerCase(),
            password: loginFormData.password,
        };
    
        try {
            const response = await axios.post(baseUrl + '/employee/login/', formData);
    
            if (response.data.bool) {
                const { access_token, refresh_token, user, id, vendor_name, employee_name } = response.data;
    
                // Store secure details in local storage
                localStorage.setItem('access_token', access_token);
                localStorage.setItem('refresh_token', refresh_token);
                localStorage.setItem('vendor_username', vendor_name);
                localStorage.setItem('staff_username', employee_name);
                localStorage.setItem('vendor_id', id);
                localStorage.setItem('vendor_login', true);
                setLoading(false);
    
                // Redirect to the dashboard
                window.location.href = '/seller/dashboard';
            } else {
                setFormError(true);
                setLoading(false);
                setErrorMsg(response.data.message || 'Login failed');
            }
        } catch (error) {
            //console.error('Login error:', error);
            setFormError(true);
            setLoading(false);
            setErrorMsg('Oops! Confirm your credentials and network connection, then try again.');
        }
    };
    
    const location = useLocation(); // Get the current route
    
    useEffect(() => {
        const token = localStorage.getItem('access_token');
    
        if (!token && location.pathname !== '/seller/staff_login') {
            // Redirect to login page if no token and not already on the login page
            window.location.href = '/seller/staff_login';
        }
    
        if (token) {
            api
                .get(baseUrl + '/vendor/validate-token/', {
                    headers: {
                        Authorization: `Bearer ${token}`,
                    },
                })
                .then((response) => {
                    if (!response.data.valid) {
                        // Invalid token
                        localStorage.clear();
                        window.location.href = '/seller/staff_login';
                    }
                })
                .catch(() => {
                    // Clear storage on error
                    localStorage.clear();
                    window.location.href = '/seller/staff_login';
                });
        }
    }, [location.pathname]); // Only re-run if the route changes

    return (
        <>
            <Helmet>
                <title>Staff Log in</title>
                <meta name="description" content={`Log in`} />
            </Helmet>
            <section className="container mtopcon normal-mt-sctn">
                <div className="row">
                    <div className="col-12 col-lg-4 reglogincon">
                        <div className="card shadow-none">
                            <div className="card-body">
                                <div className='text-center mb-3'><span className="badge rounded-pill text-bg-success">Staff Login</span></div>
                                <h2 className='mb-3 text-center'><b>Welcome back</b></h2>
                                {formError && <p className="text-danger text-center">{errorMsg}</p>}
                                <div className="mb-3">
                                    <label htmlhtmlfor="lnm" className="form-label mb-0 font9 grey-text">Staff Name</label>
                                    <input
                                        type="text"
                                        name="username"
                                        value={loginFormData.username}
                                        onChange={inputHandler}
                                        className="form-control"
                                        id="lnm"
                                    />
                                    {UsernameError && <small className="text-danger font8">*Confirm staff name.</small>}
                                </div>
                                <div className="mb-3">
                                    <label htmlhtmlfor="InputPassword1" className="form-label mb-0 font9 grey-text">Password</label>
                                    <div className="input-group">
                                        <input 
                                            type={showPassword ? "text" : "password"} 
                                            name="password" 
                                            onChange={inputHandler} 
                                            value={loginFormData.password} 
                                            className="form-control font9 br-0" 
                                            id="InputPassword1" 
                                        />
                                        <button 
                                            type="button" 
                                            className="btn btn-outline-grey bl-0" 
                                            onClick={() => setShowPassword(!showPassword)}
                                            tabIndex={-1}
                                        >
                                            {showPassword ? <EyeOff size={18} /> : <Eye size={18} />}
                                        </button>
                                    </div>
                                    {PasswordError && <small className="text-danger font8">*Confirm password.</small>}
                                </div>
                                <div className="mb-3 font9 text-right">
                                    <p><Link to="/seller/staff-reset-link" className='grey-text'>Forgot Password?</Link></p>
                                </div>
                                <button
                                    type="button"
                                    onClick={submitHandler}
                                    className="col-12 btn btn-dark"
                                >
                                    { loading === true ? <>Loading...</> : <>Continue</>}
                                </button>

                                <div className="mb-3 f85 mt-4 grey-text text-center">
                                    <p>Vendor Dashboard Login? <Link to="/seller/login"  className='grey-text'><b>Proceed</b></Link></p>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </section>
        </>
    );
}

export default StaffLogin;
